import { Target, Eye, Zap } from "lucide-react";

const cards = [
  {
    icon: <Target className="h-8 w-8 text-seafarer-orange group-hover:animate-pulse transition-transform" />,
    bg: "from-seafarer-orange/30 to-seafarer-orange/80",
    title: "Our Mission",
    text: `Our mission is to establish a model framework that bolsters the National Development Plans (NDP's), and create a follow-up mechanism that supports Namibian Fisherman as equal partners in the fight against poverty.`,
    delay: "[animation-delay:0ms]"
  },
  {
    icon: <Eye className="h-8 w-8 text-seafarer-purple group-hover:animate-pulse transition-transform" />,
    bg: "from-seafarer-purple/30 to-seafarer-purple/80",
    title: "Our Vision",
    text: `The Federation strives to build at least 1200 Houses within the period of 6-10 years. And generate exceptional talent, and expand investment opportunities and initiatives to improve the welfare of fishermen and their families.`,
    delay: "[animation-delay:200ms]"
  },
  {
    icon: <Zap className="h-8 w-8 text-seafarer-blue group-hover:animate-pulse transition-transform" />,
    bg: "from-seafarer-blue/30 to-seafarer-blue/80",
    title: "Our Impact",
    text: `We aim to reduce concentrated poverty and racial wealth gap within harbor towns. By 2021, we raised approximately N$ 880,000.00 through monthly contributions, with prospects to double this amount within the next two years.`,
    delay: "[animation-delay:400ms]"
  },
];

const MissionVisionSection = () => {
  return (
    <section className="section-padding bg-gradient-to-br from-seafarer-orange/5 to-seafarer-purple/5">
      <div className="page-container">
        <div className="text-center mb-14 animate-fade-in-up">
          <h2 className="text-4xl md:text-5xl font-extrabold mb-3 gradient-text">Mission, Vision & Impact</h2>
          <p className="text-lg text-white max-w-2xl mx-auto">
            Empowering harbor communities through sustainable housing, opportunity, and unity.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cards.map((card, i) => (
            <div
              key={card.title}
              className={`group seafarer-card p-8 animate-fade-in-up ${card.delay} hover:scale-105 transition-transform duration-300 shadow-xl relative overflow-hidden`}
            >
              <div className={`inline-flex items-center justify-center h-16 w-16 rounded-full bg-gradient-to-br ${card.bg} mb-6 shadow-lg transition-all duration-300`}>
                {card.icon}
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white drop-shadow-lg">{card.title}</h3>
              <p className="text-gray-700 dark:text-gray-200 text-base leading-relaxed">{card.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionVisionSection;
